"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sp10 = void 0;
const favicon_ico_1 = __importDefault(require("./logo/favicon.ico"));
const servicepro_125x125_png_1 = __importDefault(require("./logo/gray/servicepro-125x125.png"));
const servicepro_tagline_580x120_jpg_1 = __importDefault(require("./logo/gray/servicepro-tagline-580x120.jpg"));
const servicepro_236x40_png_1 = __importDefault(require("./logo/servicepro-236x40.png"));
const service_pro_logo_no_text_125x125_png_1 = __importDefault(require("./logo/service-pro-logo-no-text-125x125.png"));
exports.sp10 = {
    name: "Service Pro 10",
    "msi-color": "#9f0000",
    "loading-dots-color": "#ee3e35",
    "login-header-logo-url": servicepro_236x40_png_1.default,
    "login-logo-url": servicepro_125x125_png_1.default,
    "app-logo-url": servicepro_125x125_png_1.default,
    "app-logo-color-url": service_pro_logo_no_text_125x125_png_1.default,
    "app-logo-tagline-url": servicepro_tagline_580x120_jpg_1.default,
    favicon: favicon_ico_1.default,
    "banner-background-color": "#333333",
    "drawer-selected-background-color": "#000000",
    "login-text-color": "#606060",
    "input-background-hover-color": "#ffffff",
    "body-background-color": "#e9e9e9",
    "banner-tab-link-color": "#dedede",
    "banner-link-color": "#9ed4f9",
    "banner-active-module-link-color": "#ffffff",
    "banner-skew-background-color": "#656d72",
    "banner-nav-bar-separator-color": "#646464",
    "top-toolbar-top-background-color": "#dce5ec",
    "top-toolbar-bottom-background-color": "#eef4f9",
    "top-toolbar-bottom-border-color": "#b1b1b1",
    "top-toolbar-inset-background-color": "#d8e3ed",
    "top-toolbar-inset-border-color": "#cbd7d1",
    "top-toolbar-inset-top-border-color": "#b2c0ca",
    "top-toolbar-inset-bottom-border-color": "#fcfdfe",
    "app-link-color": "#3084bf",
    "hover-color": "#f89406",
    "active-color": "#777777",
    "menu-border-color": "#777777",
    "input-color": "#212121",
    "header-color": "#555",
    "success-color": "#0ac92b",
    "scheduler-active-color": "#dff0d8",
    "scheduler-active-border-color": "#b2dba1",
    "scheduler-warning-color": "#fcf8e3",
    "scheduler-warning-border-color": "#f5e79e",
    "scheduler-offline-color": "#f2dede",
    "scheduler-offline-border-color": "#dca7a7",
    "scheduler-info-color": "#d9edf7",
    "scheduler-info-border-color": "#9acfea",
    "disabled-color": "rgba(0,0,0,0.30)",
    "disabled-background-color": "#f9f9f9",
    "disabled-border-color": "#c3c3c3",
    "disabled-background-color-grid": "#ddd",
    "input-background-color": "#f9f9f9",
    "input-border-color": "#b3b3b3",
    "label-color": "#212121",
    "dropdown-color": "#212121",
    "action-button-color": "#383838",
    "action-button-border-color": "#adb5ba",
    "action-button-background-color": "#f9f9f9",
    "action-button-hover-text-color": "#ffffff",
    "action-button-disabled-color": "#adadad",
    "action-button-border-disabled-color": "#c9d0d4",
    "action-button-success-background-color": "#dff0d8",
    "action-button-fail-background-color": "#f2dede",
    "alert-color": "#ff6e6e",
    "alert-danger-color": "#f2dede",
    "alert-warning-color": "#fcf8e3",
    "alert-success-color": "#dff0d8",
    "alert-info-color": "#d9edf7",
    "validation-border-color": "#dca7a7",
    "validation-background-color": "#f2dede",
    "left-column-label-color": "#808080",
    "workarea-label-color": "#808080",
    "horizontal-separator-color": "#bcbfc1",
    "pane-border-color": "#ffffff",
    "pane-header-color": "#60696f",
    "pane-body-background-color": "#e7eef4",
    "dropdown-header-color": "#e3e7e8",
    "dropdown-border-color": "#7e7e7e",
    "dropdown-shadow-color": "#424242",
    "popup-background-color": "#ffffff",
    "popup-border-color": "#7e7e7e",
    "popup-shadow-color": "#3d3d3d",
    "popup-content-background-color": "#f9f9f9",
    "popup-content-border-color": "#b2b2b2",
    "popup-content-shadow-color": "#d6d6d6",
    "popup-header-color": "#212121",
    "popup-label-color": "#808080",
    "popup-field-color": "#212121",
    "tab-selected-background-color": "#b1b1b1",
    "tab-selected-color": "#f9f9f9",
    "selected-background-color": "#428bca",
    "selected-border-color": "#428bca",
    "tab-border-color": "#b1b1b1",
    "tab-background-color": "#fafafa",
    "badge-text-color": "#f9f9f9",
    "alt-row-color": "#eff3f4",
    "group-column-color": "#ffffff",
    "legend-background-color": "#f1f8fe",
    "woop-container-background-color": "#d3dee2",
    "woop-container-border-color": "#b8b8b9",
    "loading-text-color": "#000",
    "watermark-text": "#ccc",
    "pulse-color": "#f89406",
    "pulse-color-rgb": "rgb(248,148,6)",
    "font-family": "Segoe UI, Trebuchet MS, Tahoma, Verdana, Arial, sans-serif",
    green: "#b2dba1",
    yellow: "#FFCC00",
    red: "#ff6e6e",
    "custom-css": `
            .k-button.k-primary:hover {
               color: hsla(35, 95%, 60%, 1) !important;
            }
         `
};
//# sourceMappingURL=sp10.js.map